import { MoveGenerator } from '../../jscaip/AI/AI';
import { SiamRules } from './SiamRules';
export class SiamMoveGenerator extends MoveGenerator {
    getListMoves(node, config) {
        let moves = [];
        const currentPlayer = node.gameState.getCurrentPlayer();
        for (const coordAndContent of node.gameState.getCoordsAndContents()) {
            const piece = coordAndContent.content;
            if (piece.belongsTo(currentPlayer)) {
                moves = moves.concat(SiamRules.get().getMovesFrom(node.gameState, piece, coordAndContent.coord.x, coordAndContent.coord.y));
            }
        }
        if (node.gameState.countCurrentPlayerPawn() < config.numberOfPiece) {
            // up to 44 insertions
            // we remove some legal but useless insertions as explained below
            for (const insertion of SiamRules.get().getInsertions(node.gameState, config)) {
                if (insertion.direction.get().getOpposite() === insertion.landingOrientation) {
                    // this is an insertion with an orientation opposite to its direction,
                    // these are always a useless move and we don't want to take them into account here
                    continue;
                }
                else if (node.gameState.isEdge(insertion.coord) &&
                    insertion.direction.get() !== insertion.landingOrientation) {
                    // this insertion is made in the corner but is not forward, so it cannot push
                    // there is always an equivalent insertion from the other entrance to the same corner,
                    // but the other one is able to push so it is strictly better
                    continue;
                }
                else {
                    moves.push(insertion);
                }
            }
        }
        return moves;
    }
}
